// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth[data-v-4ae58fc6]{background:#102767}.form[data-v-4ae58fc6]{background:#2e3a6e}.purple-bg[data-v-4ae58fc6]{background:#5e6da8;color:#fff}.main[data-v-4ae58fc6]{font-size:24px;line-height:48px}.mini[data-v-4ae58fc6]{font-size:14px;line-height:22px;margin:5px auto}", ""]);
// Exports
module.exports = exports;
